import db from './db'
import { KeyAction } from './types'

export default class Storage {
  handleAction(action: KeyAction) {
    // TODO: throttle saves
    db.collection('keyActions').add(action)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Storage.ts